import { Container } from '@/components';
import styled from 'styled-components';
import React, { useContext } from 'react';
import { ConnectedAccountContext } from '@/contexts/ConnectedAccountContext';

import { PageTile, HeaderText } from '@make-software/cspr-design';
import { MessageTable } from '@/components';

import { useMessagesReceivedByAccount } from '@/hooks';

const PageContentSection = styled.section(({ theme }) =>
  theme.withMedia({
    maxWidth: ['100%', '720px', '1200px'],
    width: '100%',
    margin: '0 auto',
    padding: '0 12px',
    paddingTop: '48px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  })
);

const InboxScene = () => {
  const connectedAccount = useContext(ConnectedAccountContext);

  if (!connectedAccount) {
    return null;
  }

  return (
    <Container>
      <PageContentSection>
        <HeaderText size={2}>Inbox</HeaderText>
        <PageTile>
          <MessageTable dataLoader={(page: number, perPage: number) =>
            useMessagesReceivedByAccount(connectedAccount.public_key, page, perPage)
          } />
        </PageTile>
      </PageContentSection>
    </Container>
  );
};

export default InboxScene;
